import {
    Button,
    ButtonSizes,
    ButtonStyles,
    DonutChart,
    Dropdown,
    EmptyState,
    EmptyStateIcons,
    HexColor,
    Icons,
    LayoutCarousel
} from '@silverfort/sf-components';
import { FC } from 'react';
import { entityProtocolUsageExport } from '../../Investigation/InvestigationUtils';
import { CHART_COLORS } from '@silverfort-nodelibs/common/utils/consts';
import { COLOR_BY_PROTOCOL } from './consts';

const DAYS_ITEMS = [
    {
        title: '24 Hours',
        value: '1'
    },
    {
        title: '7 Days',
        value: '7'
    },
    {
        title: '30 Days',
        value: '30'
    }
];

interface IdentityDataActivityChartProps {
    protocolUsage: { count: number; protocol_type: string }[];
    daysFilter: string;
    setDaysFilter: (val: string) => void;
    isLoading: boolean;
    totalAuths: number;
}

const IdentityDataActivityChart: FC<IdentityDataActivityChartProps> = ({
    protocolUsage,
    daysFilter,
    setDaysFilter,
    isLoading,
    totalAuths
}) => {
    return protocolUsage?.length ? (
        <>
            <div className="h-8 w-full flex items-center justify-end">
                <div className="flex gap-1 items-center">
                    <span className="text-12 font-medium text-sf-gray-800">Latest activity</span>
                    <Dropdown
                        className="w-[128px]"
                        size="small"
                        onChange={(value) => setDaysFilter(value as string)}
                        selectedItems={daysFilter}
                        items={DAYS_ITEMS}
                        variant="trigger"
                    />
                    <Button
                        onClick={() => entityProtocolUsageExport(protocolUsage)}
                        buttonSize={ButtonSizes.Small}
                        buttonStyle={ButtonStyles.TertiaryBorder}
                        iconLeft={Icons.Download}
                    />
                </div>
            </div>
            <div>
                <LayoutCarousel
                    title="Authentication Protocol"
                    pages={[
                        <DonutChart
                            isLoading={isLoading}
                            data={
                                protocolUsage.map((usage, index) => ({
                                    name: usage.protocol_type,
                                    value: usage.count,
                                    fill: (COLOR_BY_PROTOCOL[usage.protocol_type.toLowerCase()] as HexColor) || (CHART_COLORS[0] as HexColor)
                                })) || []
                            }
                            totalText={totalAuths}
                            isMappingVisible
                        />
                    ]}
                />
            </div>
        </>
    ) : (
        <>
            <div className="h-8 w-full flex items-center justify-end">
                <div className="flex gap-1 items-center">
                    <span className="text-12 font-medium text-sf-gray-800">Latest activity</span>
                    <Dropdown
                        className="w-[128px]"
                        size="small"
                        onChange={(value) => setDaysFilter(value as string)}
                        selectedItems={daysFilter}
                        items={DAYS_ITEMS}
                        variant="trigger"
                    />
                </div>
            </div>
            <div className="w-full flex justify-center">
                <EmptyState
                    icon={EmptyStateIcons.NoResults}
                    title="No activity currently detected"
                    description="Activity is not available for the selected time range. You can modify the time range using the dropdown menu above."
                />
            </div>
        </>
    );
};

export default IdentityDataActivityChart;
